module.exports = __webpack_public_path__ + "static/caresLogo-e44640db13a03f0d1ab55401f4dbf444.jpg";